import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class EngagementTermsWorkScope extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_engagement_terms_and_work_scope');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'nature_of_engagement')}><i class="fas fa-file-download"></i> Nature of Engagement:Retainer</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'non_compete_declaration')}><i class="fas fa-file-download"></i> Non-Compete &amp; Conflict of Interest Declaration</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'confidentiality_agreement')}><i class="fas fa-file-download"></i> Confidentiality &amp; NDA Compliance Agreement</a></div>);
    downloads_div.push(<div className="col-md-4"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'fee_and_payment_terms')}><i class="fas fa-file-download"></i> Fee &amp; Payment Terms</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'part_time_employee_engagement_terms_and_work_scope';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
    }else{
      url = "/php/admin_part_time_employee_management_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#expected_billable_hours').val(data['expected_billable_hours']);
    $('#termination_and_exit_clause').val(data['termination_and_exit_clause']);

    $('#old_nature_of_engagement').val(data['nature_of_engagement_new_name']);
    $('#old_confidentiality_agreement').val(data['confidentiality_agreement_new_name']);
    $('#old_fee_and_payment_terms').val(data['fee_and_payment_terms_new_name']);
    $('#old_non_compete_declaration').val(data['non_compete_declaration_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['png','jpg','jpeg','JPEG','JPG','PNG','pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());

    var expected_billable_hours    = window.isNullAndUndef($('#expected_billable_hours').val());
    var termination_and_exit_clause          = window.isNullAndUndef($('#termination_and_exit_clause').val());

    var nature_of_engagement_temp    = window.isNullAndUndef($('#nature_of_engagement').val());
    var org_nature_of_engagement     = $("#nature_of_engagement").prop("files")[0];
    var nature_of_engagement_name    = $('#nature_of_engagement').val().split('\\').pop();

    var confidentiality_agreement_temp        = window.isNullAndUndef($('#confidentiality_agreement').val());
    var org_confidentiality_agreement         = $("#confidentiality_agreement").prop("files")[0];
    var confidentiality_agreement_name        = $('#confidentiality_agreement').val().split('\\').pop();

    var fee_and_payment_terms_temp        = window.isNullAndUndef($('#fee_and_payment_terms').val());
    var org_fee_and_payment_terms         = $("#fee_and_payment_terms").prop("files")[0];
    var fee_and_payment_terms_name        = $('#fee_and_payment_terms').val().split('\\').pop();

    var non_compete_declaration_temp        = window.isNullAndUndef($('#non_compete_declaration').val());
    var org_non_compete_declaration         = $("#non_compete_declaration").prop("files")[0];
    var non_compete_declaration_name        = $('#non_compete_declaration').val().split('\\').pop();


    var nature_of_engagement_ext    = '';
    var confidentiality_agreement_ext  = '';
    var fee_and_payment_terms_ext  = '';
    var non_compete_declaration_ext  = '';

    if(nature_of_engagement_temp && confidentiality_agreement_temp && fee_and_payment_terms_temp && non_compete_declaration_temp){
      nature_of_engagement_ext       = nature_of_engagement_temp.split('.').pop();
      confidentiality_agreement_ext        = confidentiality_agreement_temp.split('.').pop();
      fee_and_payment_terms_ext        = fee_and_payment_terms_temp.split('.').pop();
      non_compete_declaration_ext        = non_compete_declaration_temp.split('.').pop();
    }
    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(expected_billable_hours && termination_and_exit_clause && file_main_ext.indexOf(nature_of_engagement_ext) >= 0 && file_main_ext.indexOf(confidentiality_agreement_ext) >= 0 && file_main_ext.indexOf(fee_and_payment_terms_ext) >= 0 && file_main_ext.indexOf(non_compete_declaration_ext) >= 0){
      var old_nature_of_engagement                 = $('#old_nature_of_engagement').val();
      var old_confidentiality_agreement                  = $('#old_confidentiality_agreement').val();
      var old_fee_and_payment_terms                  = $('#old_fee_and_payment_terms').val();
      var old_non_compete_declaration                  = $('#old_non_compete_declaration').val();
      var all_data                              = {};
      all_data['expected_billable_hours']        = window.return_false_null(expected_billable_hours);
      all_data['termination_and_exit_clause']              = window.return_false_null(termination_and_exit_clause);

      all_data['nature_of_engagement']             = window.return_false_null(nature_of_engagement_name);
      all_data['confidentiality_agreement']                 = window.return_false_null(confidentiality_agreement_name);
      all_data['fee_and_payment_terms']                 = window.return_false_null(fee_and_payment_terms_name);
      all_data['non_compete_declaration']                 = window.return_false_null(non_compete_declaration_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('nature_of_engagement',org_nature_of_engagement);
      body.append('old_nature_of_engagement',old_nature_of_engagement);
      body.append('confidentiality_agreement',org_confidentiality_agreement);
      body.append('old_confidentiality_agreement',old_confidentiality_agreement);
      body.append('fee_and_payment_terms',org_fee_and_payment_terms);
      body.append('old_fee_and_payment_terms',old_fee_and_payment_terms);
      body.append('non_compete_declaration',org_non_compete_declaration);
      body.append('old_non_compete_declaration',old_non_compete_declaration);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','part_time_employee_engagement_terms_and_work_scope');
      body.append('function','add_part_time_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_part_time_employee_management_url.php";
      }else{
        url = "/php/admin_part_time_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('expected_billable_hours','termination_and_exit_clause','nature_of_engagement','confidentiality_agreement','fee_and_payment_terms','non_compete_declaration');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_nature_of_engagement" placeholder=""/>
                                        <input type="file" className="form-control" id="nature_of_engagement" placeholder="Nature of Engagement"/>
                                        <label for="name">Nature of Engagement</label>
                                    </div>
                                </div>


                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_non_compete_declaration" placeholder=""/>
                                        <input type="file" className="form-control" id="non_compete_declaration" placeholder="Non-Compete &amp; Conflict of Interest Declaration"/>
                                        <label for="name">Non-Compete &amp; Conflict of Interest Declaration</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_confidentiality_agreement" placeholder=""/>
                                        <input type="file" className="form-control" id="confidentiality_agreement" placeholder="Confidentiality &amp; NDA Compliance Agreement"/>
                                        <label for="name">Confidentiality &amp; NDA Compliance Agreement</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_fee_and_payment_terms" placeholder=""/>
                                        <input type="file" className="form-control" id="fee_and_payment_terms" placeholder="Fee &amp; Payment Terms"/>
                                        <label for="name">Fee &amp; Payment Terms</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="expected_billable_hours" placeholder="Expected Billable Hours / Case Allocation"/>
                                        <label for="name">Expected Billable Hours / Case Allocation</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="text" className="form-control" id="termination_and_exit_clause" placeholder="Termination &amp; Exit Clause"/>
                                        <label for="name">Termination &amp; Exit Clause</label>
                                    </div>
                                </div>


                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF, JPEG, JPG & PNG</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default EngagementTermsWorkScope;
